"use strict";
/**
 * @module keyValueClient
 * @description  Key Value Client provides an easy way to consume  Key Value REST API end-points. In order to obtain needed routes `keyValueClient` uses `baasicKeyValueRouteClient`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var KeyValueClient = /** @class */ (function () {
    function KeyValueClient(keyValueRoute, apiClient) {
        this.keyValueRoute = keyValueRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(KeyValueClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `keyValueRoute`.
         * @method
         * @example keyValueClient.routeDefinition.get();
         **/
        get: function () {
            return this.keyValueRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of key value resources matching the given criteria.
     * @param options query resource options object
     * @returns A promise that is resolved once the find action has beend performed.
     * @method
     * @example keyValueClient.find({
                 pageNumber: 1,
                 pageSize: 10,
                 orderBy: '<field>',
                 orderDirection: '<asc|desc>',
                 search: '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    KeyValueClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified key value resource.
     * @param id unique identifer of key value resources
     * @param options query resource options object
     * @returns A promise that is resolved once the get action has beend performed.
     * @method
     * @example keyValueClient.get('<key-value-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    KeyValueClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.keyValueRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create key value action has been performed; this action creates a new key value resource.
     * @param data A key value object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create key value action has beend performed.
     * @method
     * @example keyValueClient.create({key: '<key>', value: '<value>', })
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     */
    KeyValueClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update key value action has been performed; this action updates a key value resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `baasicKeyValueRouteService` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(keyValue);
     * let uri = params['model'].links('put').href;
     * ```
     * @param data A key value object used to update specified key value resource.
     * @return A promise that is resolved once the update key value action has been performed.
     * @method
     * @example // keyValue is a resource previously fetched using get action.
                   keyValue.value = '<new-value>';
                   keyValueClient.update(keyValue)
                   .then(function (data) {
                       // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    KeyValueClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a key value resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `baasicKeyValueRouteService` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(keyValue);
     * let uri = params['model'].links('delete').href;
     * ```
     * @param data A key value object used to delete specified key value resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @method
     * @example // keyValue is a resource previously fetched using get action.
                    keyValueClient.remove(keyValue)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    KeyValueClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data), this.routeDefinition.deleteParams(data));
    };
    var _a, _b;
    KeyValueClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.KeyValueRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.KeyValueRoute !== "undefined" && _1.KeyValueRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], KeyValueClient);
    return KeyValueClient;
}());
exports.KeyValueClient = KeyValueClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
